import axios from 'axios'

const { VUE_APP_TEST_ERROR, VUE_APP_API_URL, VUE_APP_AMEX, VUE_APP_VT_API_URL } = process.env

const loadPaymentHistory = async (username, bookingNumber, branchNumber, source, system, fil) => {
  const result = { error: false }

  try {
    // will normally be ext, only internal consultants will change it to int
    let sourceParam = 'INT'
    if (source) sourceParam = source.toUpperCase()
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/superfacts/payments`
    const res = await axios.post(url, {
      bookingName: username,
      bookingNumber: bookingNumber,
      branch: branchNumber,
      fil: fil,
      source: sourceParam,
      system: system,
    })
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

// Call when user selects checkbox and agrees terms of payment
const paymentConfirm = async (username, bookingNumber) => {
  try {
    // send payment confirmation before payments
    await axios.post(`${VUE_APP_API_URL}/api/viewtrail/paymentconfirm`, {
      name: username,
      bookno: bookingNumber,
    })
  } catch (err) {
    return null
  }
}

// Amex bank transfer call
const amexButtonPayment = async (booking, amount, passengerData, inputEmail, utils) => {
  try {
    const randomNum = Math.random().toString(36).slice(-6).toUpperCase()
    window.$pwb.openWindow()
    // send payment confirmation before payments
    const res = await axios.post(`${VUE_APP_AMEX}/button`, {
      tf_system: 'Viewtrail',
      redirect: `https://www.trailfinders.com/viewtrail/viewtrail.html#/amexpayment/${booking.user_information.bookingNumber}/${booking.booking_information.lead_surname}`,
      orderId: `${booking.user_information.bookingNumber}-${randomNum}`,
      amount: Number(amount),
      customerId: booking.booking_information.custno,
      orderType: booking.account_information.fil,
      branchTelephone: booking.consultant_information.branchContact[0].line0.telno,
      branch: booking.booking_information.contact_branch,
      branchNo: booking.booking_information.branch_number,
      email: inputEmail,
      name: passengerData.name,
      logname: booking.booking_information.logname,
      passenger: passengerData,
      issueFlights: utils.issueFlights,
      incProvIns: utils.incProvIns
    })
    if (res && res.data) {
      window.$pwb.updateInit(res.data)
      return res.data
    }
  } catch (err) {
    window.$pwb.updateInit(false)
    return null
  }
}

const sendRedeemConfirmationEmail = async (emailObj) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/redeemConfirmationEmail`,
      emailObj
    )
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const isOfficeOpen = async () => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/officeOpen`, {})
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const logToPapertrail = async (data) => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/logging`, { data: data })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const getBookingPassengers = async (token, bookingNumber) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/getBookingPassengers`,
      { bookingNumber },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export {
  loadPaymentHistory,
  isOfficeOpen,
  paymentConfirm,
  amexButtonPayment,
  sendRedeemConfirmationEmail,
  getBookingPassengers,
  logToPapertrail,
}
